export const InputField = ({ label, placeholder, name, value, onChange, type = 'text', required, errors, disabled }) => (
    <div className="w-full">
      {label && <label className="block mb-2 text-lg text-white font-semibold">{label}</label>}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`block w-full p-3 bg-transparent text-gray-100 border disabled:text-gray-500 border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 ${disabled ? "text-gray-500 border-gray-300" : "text-gray-100"}`}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete="off"
      />
      {errors && <p className="text-red-500">{errors}</p>}
    </div>
    
  );
  
  export const NumberField = ({ label, name, value, onChange, type = 'number', required = true, errors }) => (
    <div className="w-full">
      <div className="flex items-end gap-2">
  <label className="block text-md font-medium text-white font-semibold text-nowrap">{label}</label>
  <input
    type={type}
    name={name}
    value={value}
    onChange={onChange}
    className="block w-full text-sm text-gray-100 focus:outline-none bg-transparent border-0 border-b border-gray-300 dark:border-gray-600 focus:border-b-2 focus:border-gray-300 focus:ring-0 hover:border-b-2 hover:border-gray-500 peer"
    required={required}
    autoComplete="off"
  /></div>
   {errors && <p className="text-red-500 text-center">{errors}</p>}
</div>

  );



  export const NumberFieldBorder = ({ label, placeholder, name, value, onChange, type = 'number', required, errors }) => (
    <div className="w-full">
      <label className="block mb-2 text-lg text-white font-semibold">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="block w-full p-3 bg-transparent text-gray-100 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        placeholder={placeholder}
        required={required}
        autoComplete="off"
      />
      {errors && <p className="text-red-500">{errors}</p>}
    </div>
    
  );


  export const InputFieldWithOutBorder = ({ label, name, value, onChange, type = 'text', required = true, errors }) => (
    <div className="w-full">
      <div className="flex items-end gap-2">
  <label className="block text-md font-medium text-white font-semibold text-nowrap">{label}</label>
  <input
    type={type}
    name={name}
    value={value}
    onChange={onChange}
    className="block w-full text-sm text-gray-100 focus:outline-none bg-transparent border-0 border-b border-gray-300 dark:border-gray-600 focus:border-b-2 focus:border-gray-300 focus:ring-0 hover:border-b-2 hover:border-gray-500 peer"
    required={required}
    autoComplete="off"
  /></div>
   {errors && <p className="text-red-500 text-center">{errors}</p>}
</div>

  );